import React, { Component } from "react";
import "../css/RegisterForm.css";
import { HOST_URL, ROOT } from "../constants";
import phonecommentImage from "../images/icon-info-2.png";
import { Translation } from "react-i18next";
import Loading from "./Loading";
import { connect } from "react-redux";
import { loading } from "../models";
import { withTranslation } from "react-i18next";
import { register } from "../models";
import { withRouter } from "react-router-dom";

class RegisterForm extends Component {
  state = {
    memberData: {
      firstName: "",
      familyName: "",
      salute: "",
      residenceCountry: "HK",
      mobileCountryCode: "852",
      mobileNumber: "",
      email: "",
      emailConfirm: "",
      password: "",
      passwordConfirm: ""
    },
    warningMemberData: {
      firstName: false,
      familyName: false,
      salute: false,
      residenceCountry: false,
      mobileCountryCode: false,
      mobileNumber: false,
      email: false,
      emailConfirm: false,
      password: false,
      passwordConfirm: false
    },
    noEmail: false,
    noAge18: false,
    agreeTerms: false,
    warningAgreeTerms: false,
    warningEmailSame: false,
    warningPasswordSame: false,
    warningPasswordLength: false,
    warningPasswordConfirmLength: false,
    warningEmailType: false,
    warningEmailConfirmType: false,
    warningNumberLength: false,
    numberMaxLength: "8",
    warningFormMessage: false,
    warningFormMessageText: "",
    birthMonth: "default",
    birthDate: "default"
  };

  handleMemberData = e => {
    const { name, value } = e.target;
    this.setState({
      memberData: {
        ...this.state.memberData,
        [name]: value
      }
    });
  };

  changeCountryCode = (e, countryCodeLists) => {
    this.handleMemberData(e);
    const { value } = e.target;
    if (value === "852") {
      this.setState({
        numberMaxLength: "8"
      });
    } else if (value === "86") {
      this.setState({
        numberMaxLength: "11"
      });
    } else if (value === "853") {
      this.setState({
        numberMaxLength: "8"
      });
    } else if (value === "886") {
      this.setState({
        numberMaxLength: "9"
      });
    } else {
      this.setState({
        numberMaxLength: ""
      });
    }
    // 改變密碼最大值
    this.setState({
      // numberMaxLength: maxLength,
      memberData: {
        ...this.state.memberData,
        mobileNumber: "",
        mobileCountryCode: value
      }
    });
  };

  noEmailOption = e => {
    // 會員沒有電子郵件
    const { checked } = e.target;
    this.setState({
      noEmail: checked,
      memberData: {
        ...this.state.memberData,
        email: "",
        emailConfirm: ""
      }
    });
    // 選擇沒有電子郵件，清空錯誤訊息
    if (checked) {
      this.setState({
        warningEmailType: false,
        warningEmailConfirmType: false,
        warningEmailSame: false,
        warningMemberData: {
          ...this.state.warningMemberData,
          email: false,
          emailConfirm: false
        }
      });
    }
  };

  noAge18 = e => {
    // 會員未滿18歲
    const { checked } = e.target;
    this.setState({
      noAge18: checked
    });
  };

  agreeTerms = e => {
    const { checked } = e.target;
    this.setState({
      agreeTerms: checked
    });
  };

  changeBirth = (e, months, days) => {
    const { name, value } = e.target;
    const { birthDate, birthMonth } = this.state;
    this.setState({
      [name]: value
    });
    // 如果選了月份，強制選擇日期為1日
    if (name === "birthMonth" && birthDate === "default") {
      this.setState({
        birthDate: "01"
      });
    }
    // 如果選了日期，強制選擇月份為1月
    if (name === "birthDate" && birthMonth === "default") {
      this.setState({
        birthMonth: "01"
      });
    }
    // 如果選的日期大於當月的天數，強制改為1日
    if (name === "birthMonth") {
      const activeMonth = months.findIndex(data => data.value === value);
      const activeDays = days[activeMonth];
      if (birthDate > activeDays) {
        this.setState({
          birthDate: "01"
        });
      }
    }
  };

  howManyDays = (months, days) => {
    const { birthDate, birthMonth } = this.state;
    const { lang } = this.props;
    const activeMonth = months.findIndex(data => data.value === birthMonth);
    const activeDays = days[activeMonth];
    let array = [];
    let i;
    if (birthDate === "default") {
      // 當沒有選擇月份，一律生成31天
      for (i = 1; i <= 31; i++) {
        array.push(
          <option key={i} value={i < 10 ? `0${i}` : i}>
            {i}
            {lang === "zhTW" ? "日" : ""}
          </option>
        );
      }
    } else {
      // 當有選擇月份時，則根據當月的天數生成
      for (i = 1; i <= activeDays; i++) {
        array.push(
          <option key={i} value={i < 10 ? `0${i}` : i}>
            {i}
            {lang === "zhTW" ? "日" : ""}
          </option>
        );
      }
    }
    return array;
  };

  submitMemberData = async () => {
    const { noEmail, memberData, warningMemberData, agreeTerms } = this.state;
    const dataLists = Object.keys(memberData);
    // 先判斷有無電子郵件
    if (noEmail) {
      //  不檢查電子郵件
      dataLists.map(key => {
        if (memberData[key] === "") {
          return (warningMemberData[key] = true);
        } else {
          return (warningMemberData[key] = false);
        }
      });
      await this.setState({
        warningMemberData: warningMemberData
      });
      // 不顯示 email 錯誤訊息
      await this.setState({
        warningMemberData: {
          ...this.state.warningMemberData,
          email: false,
          emailConfirm: false
        }
      });
      // 不顯示 password 不一致訊息
      await this.setState({
        warningPasswordSame: false
      });
      // 檢查密碼
      this.checkPasswordAreSame();
      // 檢查手機號碼
      this.checkMobileNumber();
    } else {
      // 檢查電子郵件
      dataLists.map(key => {
        if (memberData[key] === "") {
          return (warningMemberData[key] = true);
        } else {
          return (warningMemberData[key] = false);
        }
      });
      await this.setState({
        warningMemberData: warningMemberData
      });
      //
      await this.setState({
        warningPasswordSame: false,
        warningEmailSame: false
      });
      // 檢查密碼
      this.checkPasswordAreSame();
      // 檢查信箱
      this.checkEmailAreSame();
      // 檢查手機號碼
      this.checkMobileNumber();
    }
    // 檢查會員條款
    if (agreeTerms) {
      await this.setState({
        warningAgreeTerms: false
      });
    } else {
      await this.setState({
        warningAgreeTerms: true
      });
    }
    await this.goRegister();
  };

  checkMobileNumber = () => {
    // 1.判斷手機號碼是否填寫
    const { warningMemberData, numberMaxLength, memberData } = this.state;
    if (!warningMemberData.mobileNumber) {
      // 2.有填寫
      const phoneNumber = Number(memberData.mobileNumber);

      if (
        (memberData.mobileNumber.length === parseInt(numberMaxLength) &&
          !isNaN(phoneNumber)) ||
        (numberMaxLength === "" && !isNaN(phoneNumber))
      ) {
        // 2-1.格式與長度都正確
        this.setState({
          warningNumberLength: false
        });
      } else {
        // 2-2. 格式與長度有誤
        this.setState({
          warningNumberLength: true
        });
      }
    } else {
      // 3.沒填寫
      this.setState({
        warningNumberLength: false
      });
    }
  };

  checkPasswordAreSame = () => {
    // 1. 是否大於6
    // 2. 是否都填寫完畢
    // 3. 是否相等
    const { warningMemberData, memberData } = this.state;
    if (memberData.password.length >= 6) {
      this.setState({
        warningPasswordLength: false
      });
      // 判斷是否相等
      if (memberData.password === memberData.passwordConfirm) {
        // 密碼相等
        this.setState({
          warningPasswordSame: false
        });
      } else {
        // 密碼不相等且是否都填寫了
        if (!warningMemberData.password && !warningMemberData.passwordConfirm) {
          this.setState({
            warningPasswordSame: true
          });
        } else {
          this.setState({
            warningPasswordSame: false
          });
        }
      }
    } else {
      if (!warningMemberData.password) {
        this.setState({
          warningPasswordLength: true
        });
      } else {
        this.setState({
          warningPasswordLength: false
        });
      }
    }
    if (memberData.passwordConfirm.length >= 6) {
      this.setState({
        warningPasswordConfirmLength: false
      });
      // 判斷是否相等
      if (memberData.password === memberData.passwordConfirm) {
        // 密碼相等
        this.setState({
          warningPasswordSame: false
        });
      } else {
        // 密碼不相等且是否都填寫了
        if (!warningMemberData.password && !warningMemberData.passwordConfirm) {
          this.setState({
            warningPasswordSame: true
          });
        } else {
          this.setState({
            warningPasswordSame: false
          });
        }
      }
    } else {
      if (!warningMemberData.passwordConfirm) {
        // 字符不足6，也可能且不相等的情況
        this.setState({
          warningPasswordConfirmLength: true
        });
      } else {
        this.setState({
          warningPasswordConfirmLength: false
        });
      }
    }
  };

  checkEmailAreSame = () => {
    const { warningMemberData, memberData } = this.state;
    if (!warningMemberData.email && !warningMemberData.emailConfirm) {
      if (memberData.email === memberData.emailConfirm) {
        this.setState({
          warningEmailSame: false
        });
      } else {
        this.setState({
          warningEmailSame: true
        });
      }
    }

    const emailRule = new RegExp(
      "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$"
    );

    const emailCorrect = emailRule.test(memberData.email);
    const emailConfirmCorrect = emailRule.test(memberData.emailConfirm);

    if (!warningMemberData.email) {
      if (emailCorrect) {
        // 有填寫且格式正確
        this.setState({
          warningEmailType: false
        });
      } else {
        // 有填寫且格式錯誤
        this.setState({
          warningEmailType: true
        });
      }
    } else {
      this.setState({
        warningEmailType: false
      });
    }

    if (!warningMemberData.emailConfirm) {
      if (emailConfirmCorrect) {
        // 有填寫且格式正確
        this.setState({
          warningEmailConfirmType: false
        });
      } else {
        // 有填寫且格式錯誤
        this.setState({
          warningEmailConfirmType: true
        });
      }
    } else {
      this.setState({
        warningEmailConfirmType: false
      });
    }
  };

  goRegister = async () => {
    const {
      warningMemberData,
      warningEmailSame,
      warningPasswordSame,
      warningPasswordLength,
      warningPasswordConfirmLength,
      agreeTerms,
      noEmail,
      warningEmailType,
      warningEmailConfirmType,
      warningNumberLength,
      birthMonth,
      birthDate
    } = this.state;
    const {
      firstName,
      familyName,
      salute,
      residenceCountry,
      mobileCountryCode,
      mobileNumber,
      email,
      password
    } = this.state.memberData;
    const list = Object.keys(warningMemberData);
    // 1. 表單填寫完畢
    const finishedForm = list.every(data => warningMemberData[data] === false);
    // 2. 信箱一致，且格式正確
    const finishedEmail =
      !warningEmailSame && !warningEmailType && !warningEmailConfirmType;
    // 3. 密碼一致，且長度正確
    const finishedPassword =
      !warningPasswordSame &&
      !warningPasswordLength &&
      !warningPasswordConfirmLength;
    // 4. 手機號碼長度正確
    const finishedPhoneNumber = !warningNumberLength;
    // 4. 會員條款確認
    const finishedTerms = agreeTerms;
    const allFinished =
      finishedForm &&
      finishedEmail &&
      finishedPassword &&
      finishedTerms &&
      finishedPhoneNumber;
    const data = {
      firstName,
      familyName,
      salute,
      residenceCountry,
      mobileCountryCode,
      mobileNumber,
      email: noEmail ? "NA" : email,
      password,
      dateOfBirth:
        birthMonth === "default" ? null : `${birthMonth}-${birthDate}`
    };
    const iframeElement = window.parent.document.getElementById("login");
    if (allFinished) {
      this.props.startLoading(true);

      try {
        const response = await fetch(`${HOST_URL}/shopping/v1/customers`, {
          credentials: "include",
          method: "POST",
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify(data)
        });
        if (response.status === 204) {
          this.props.startLoading(false);
          const autoLoginFormData = {
            mobileCountryCode,
            mobileNumber,
            password
          };
          // 1. 有iframe就在iframe跳轉，沒有就在當前頁面跳轉
          if (iframeElement || window.opener.g_registerWindow) {
            this.props.goCheckRegister(autoLoginFormData);
          } else {
            // 沒有iframe則透過pushHistory轉換頁面，並透過state把參數帶到新頁面
            this.props.history.push({
              pathname: `${ROOT}/check-register`,
              state: { autoLoginFormData: autoLoginFormData }
            });
          }
        } else if (response.status === 400) {
          const data = await response.json();
          if (data.hasOwnProperty("errors")) {
            data.errors.forEach(element => {
              if (element.errorCode === "E00102") {
                this.setState({
                  warningFormMessage: true,
                  warningFormMessageText: "HAD_REGISTERED"
                });
              }
              //檢查email是否有重複
              if (
                element.errorCode === "E00001" ||
                element.errorCode === "E00002"
              ) {
                this.setState({
                  warningFormMessage: true,
                  warningFormMessageText: "HAD_EMAIL_REGISTERED"
                });
              }
            });
          }
        } else {
          alert("註冊失敗");
          this.props.startLoading(false);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.props.startLoading(false);
      }
    } else {
      // 沒有完成的話
      await this.setState({
        warningFormMessage: true,
        warningFormMessageText: "NOT_FINISH"
      });
      // 修改iframe高度
      if (iframeElement) {
        const editedHeight = document.getElementById("register-content")
          .offsetHeight;
        const content = window.parent.document.getElementById("loginContent");
        content.style.height = `${editedHeight}px`;
      }
    }
  };

  render() {
    // state
    const {
      memberData,
      noEmail,
      warningMemberData,
      warningAgreeTerms,
      warningPasswordSame,
      warningEmailSame,
      warningPasswordLength,
      warningPasswordConfirmLength,
      warningEmailType,
      warningEmailConfirmType,
      warningNumberLength,
      numberMaxLength,
      noAge18,
      warningFormMessage,
      birthMonth,
      birthDate
    } = this.state;
    // props
    const { lang, isLoading, t } = this.props;
    // 稱謂列表
    const saluteLists = [
      {
        name: <Translation>{t => <>{t("registerPage.mr")}</>}</Translation>,
        value: "01"
      },
      {
        name: <Translation>{t => <>{t("registerPage.miss")}</>}</Translation>,
        value: "02"
      },
      {
        name: <Translation>{t => <>{t("registerPage.ms")}</>}</Translation>,
        value: "03"
      },
      {
        name: <Translation>{t => <>{t("registerPage.mrs")}</>}</Translation>,
        value: "04"
      }
    ];
    // 區域碼列表
    const countryCodeLists = [
      { name: "+852", value: "852", maxLength: "8" },
      { name: "+86", value: "86", maxLength: "11" },
      { name: "+853", value: "853", maxLength: "8" },
      { name: "+886", value: "886", maxLength: "9" },
      { name: "+1", value: "1", maxLength: "" },
      { name: "+1242", value: "1242", maxLength: "" },
      { name: "+1246", value: "1246", maxLength: "" },
      { name: "+1264", value: "1264", maxLength: "" },
      { name: "+1268", value: "1268", maxLength: "" },
      { name: "+1345", value: "1345", maxLength: "" },
      { name: "+1441", value: "1441", maxLength: "" },
      { name: "+1664", value: "1664", maxLength: "" },
      { name: "+1670", value: "1670", maxLength: "" },
      { name: "+1671", value: "1671", maxLength: "" },
      { name: "+1758", value: "1758", maxLength: "" },
      { name: "+1784", value: "1784", maxLength: "" },
      { name: "+1787", value: "1787", maxLength: "" },
      { name: "+1809", value: "1809", maxLength: "" },
      { name: "+1876", value: "1876", maxLength: "" },
      { name: "+1890", value: "1890", maxLength: "" },
      { name: "+1242", value: "1242", maxLength: "" },
      { name: "+20", value: "20", maxLength: "" },
      { name: "+212", value: "20", maxLength: "" },
      { name: "+213", value: "20", maxLength: "" },
      { name: "+216", value: "20", maxLength: "" },
      { name: "+218", value: "20", maxLength: "" },
      { name: "+220", value: "20", maxLength: "" },
      { name: "+221", value: "20", maxLength: "" },
      { name: "+223", value: "20", maxLength: "" },
      { name: "+224", value: "20", maxLength: "" },
      { name: "+225", value: "20", maxLength: "" },
      { name: "+226", value: "20", maxLength: "" },
      { name: "+227", value: "20", maxLength: "" },
      { name: "+228", value: "20", maxLength: "" },
      { name: "+229", value: "20", maxLength: "" },
      { name: "+230", value: "20", maxLength: "" },
      { name: "+231", value: "20", maxLength: "" }
    ];

    // 居住地列表
    const residenceLists = [
      {
        name: `${t("registerPage.hongkong")}`,
        value: "HK"
      },
      {
        name: `${t("registerPage.china")}`,
        value: "CN"
      },
      {
        name: `${t("registerPage.macau")}`,
        value: "MO"
      }
    ];
    // 月份
    const months = [
      { zhTW: "1月", en: "January", value: "01" },
      { zhTW: "2月", en: "February", value: "02" },
      { zhTW: "3月", en: "March", value: "03" },
      { zhTW: "4月", en: "April", value: "04" },
      { zhTW: "5月", en: "May", value: "05" },
      { zhTW: "6月", en: "June", value: "06" },
      { zhTW: "7月", en: "July", value: "07" },
      { zhTW: "8月", en: "August", value: "08" },
      { zhTW: "9月", en: "September", value: "09" },
      { zhTW: "10月", en: "October", value: "10" },
      { zhTW: "11月", en: "November", value: "11" },
      { zhTW: "12月", en: "December", value: "12" }
    ];
    // 每月的天數
    const days = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return (
      <div className="register-form-content">
        {isLoading && <Loading />}

        {/* 稱謂 */}
        <div className="register-form-row">
          <div className="register-list-name mobile-salute-title">
            <Translation>
              {t => <>{t("registerPage.salutation")}</>}
            </Translation>
          </div>
          <div className="register-salute-content">
            {saluteLists.map((salute, index) => (
              <label className="salute-label" key={index}>
                <input
                  type="radio"
                  name="salute"
                  value={salute.value}
                  onChange={this.handleMemberData}
                />
                <div />
                <span>{salute.name}</span>
              </label>
            ))}
          </div>
          {warningMemberData.salute ? (
            <div className="error-text-list-name">
              <Translation>
                {t => <>{t("registerPage.mandatoryField")}</>}
              </Translation>
            </div>
          ) : null}
        </div>

        <div className="register-form-row">
          {/* 姓氏 */}
          <div className="row50-content">
            <div className="register-form-row50">
              <div className="register-list-name">
                <Translation>
                  {t => <>{t("registerPage.firstName")}</>}
                </Translation>
              </div>
              <Translation>
                {t => (
                  <>
                    <input
                      type="text"
                      name="familyName"
                      value={memberData.familyName}
                      placeholder={t("registerPage.nameProof")}
                      className={`familyName-input ${
                        warningMemberData.familyName ? "error-input-text" : ""
                      }`}
                      onChange={this.handleMemberData}
                    />
                  </>
                )}
              </Translation>
            </div>
            {warningMemberData.familyName ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.firstNameError")}</>}
                </Translation>
              </div>
            ) : null}
          </div>
          {/* 名字 */}
          <div className="row50-content">
            <div className="register-form-row50">
              <div className="register-list-name">
                <Translation>
                  {t => <>{t("registerPage.familyName")}</>}
                </Translation>
              </div>
              <Translation>
                {t => (
                  <>
                    <input
                      type="text"
                      name="firstName"
                      value={memberData.firstName}
                      placeholder={t("registerPage.nameProof")}
                      className={`firstName-input  ${
                        warningMemberData.firstName ? "error-input-text" : ""
                      }`}
                      onChange={this.handleMemberData}
                    />
                  </>
                )}
              </Translation>
            </div>
            {warningMemberData.firstName ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.familyNameError")}</>}
                </Translation>
              </div>
            ) : null}
          </div>
        </div>

        <div className="register-form-row">
          {/* 出生日期 */}
          <div className="row50-content">
            <div className="register-form-row50">
              <div className="register-list-name">
                <Translation>
                  {t => <>{t("registerPage.birthdate")}</>}
                </Translation>
              </div>
              <div className="register-birthday-content">
                <select
                  style={{
                    order: lang === "en" ? "2" : "1",
                    marginRight: lang === "en" ? "" : "1rem",
                    color: birthMonth === "default" ? "#767676" : "#1a1a1a"
                  }}
                  value={birthMonth}
                  name="birthMonth"
                  onChange={e => this.changeBirth(e, months, days)}
                >
                  <Translation>
                    {t => (
                      <option value="default" disabled>
                        {t("registerPage.month")}
                      </option>
                    )}
                  </Translation>
                  {months.map((data, index) => (
                    <option key={index} value={data.value}>
                      {lang === "en" ? data.en : data.zhTW}
                    </option>
                  ))}
                </select>
                <select
                  style={{
                    order: lang === "en" ? "1" : "2",
                    marginRight: lang === "en" ? "1rem" : "",
                    color: birthDate === "default" ? "#767676" : "#1a1a1a"
                  }}
                  value={birthDate}
                  name="birthDate"
                  onChange={e => this.changeBirth(e, months, days)}
                >
                  <Translation>
                    {t => (
                      <option value="default" disabled>
                        {t("registerPage.day")}
                      </option>
                    )}
                  </Translation>
                  {this.howManyDays(months, days)}
                </select>
              </div>
            </div>
          </div>
          {/* 未滿18歲 (手機版) */}
          <div className="register-form-row row-subText age18-mobile">
            <label className="register-checkbox-label">
              <input
                type="checkbox"
                name="age18"
                checked={noAge18}
                onChange={this.noAge18}
              />
              <div />
              <span>
                <Translation>
                  {t => <>{t("registerPage.noage18")}</>}
                </Translation>
              </span>
            </label>
          </div>

          {/* 居住地區 */}
          <div className="row50-content">
            <div className="register-form-row50">
              <div className="register-list-name">
                <Translation>
                  {t => <>{t("registerPage.residentRegion")}</>}
                </Translation>
              </div>
              <select
                className="residenceCountry-select"
                value={memberData.residenceCountry}
                name="residenceCountry"
                onChange={this.handleMemberData}
              >
                {residenceLists.map((residence, index) => (
                  <option key={index} value={residence.value}>
                    {residence.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* 未滿18歲 (桌機版) */}
        <div className="register-form-row row-subText age18-desktop">
          <label className="register-checkbox-label">
            <input
              type="checkbox"
              name="age18"
              checked={noAge18}
              onChange={this.noAge18}
            />
            <div />
            <span>
              <Translation>{t => <>{t("registerPage.noage18")}</>}</Translation>
            </span>
          </label>
        </div>

        {/* 手機號碼 */}
        <div className="register-form-row">
          <div className="row50-content mobile-phone-number">
            <div className="register-form-row50">
              <div className="register-list-name">
                <Translation>
                  {t => <>{t("registerPage.mobile")}</>}
                </Translation>
              </div>
              <div className="register-phone-content">
                <select
                  className="mobileCountryCode-select"
                  value={memberData.mobileCountryCode}
                  name="mobileCountryCode"
                  onChange={e => this.changeCountryCode(e, countryCodeLists)}
                >
                  {/* {countryCodeLists.map((countryCode, index) => (
                    <option key={index} value={countryCode.value}>
                      {countryCode.name}
                    </option>
                  ))} */}
                  <option value="852">+852</option>
                  <option value="853">+853</option>
                  <option value="86">+86</option>
                  <option value="886">+886</option>
                  <option value="1">+1</option>
                  <option value="1242">+1242</option>
                  <option value="1246">+1246</option>
                  <option value="1264">+1264</option>
                  <option value="1268">+1268</option>
                  <option value="1345">+1345</option>
                  <option value="1441">+1441</option>
                  <option value="1664">+1664</option>
                  <option value="1670">+1670</option>
                  <option value="1671">+1671</option>
                  <option value="1758">+1758</option>
                  <option value="1784">+1784</option>
                  <option value="1787">+1787</option>
                  <option value="1809">+1809</option>
                  <option value="1876">+1876</option>
                  <option value="1890">+1890</option>
                  <option value="20">+20</option>
                  <option value="212">+212</option>
                  <option value="213">+213</option>
                  <option value="216">+216</option>
                  <option value="218">+218</option>
                  <option value="220">+220</option>
                  <option value="221">+221</option>
                  <option value="223">+223</option>
                  <option value="224">+224</option>
                  <option value="225">+225</option>
                  <option value="226">+226</option>
                  <option value="227">+227</option>
                  <option value="228">+228</option>
                  <option value="229">+229</option>
                  <option value="230">+230</option>
                  <option value="231">+231</option>
                  <option value="232">+232</option>
                  <option value="233">+233</option>
                  <option value="234">+234</option>
                  <option value="235">+235</option>
                  <option value="236">+236</option>
                  <option value="237">+237</option>
                  <option value="239">+239</option>
                  <option value="241">+241</option>
                  <option value="242">+242</option>
                  <option value="243">+243</option>
                  <option value="244">+244</option>
                  <option value="247">+247</option>
                  <option value="248">+248</option>
                  <option value="249">+249</option>
                  <option value="250">+250</option>
                  <option value="251">+251</option>
                  <option value="252">+252</option>
                  <option value="253">+253</option>
                  <option value="254">+254</option>
                  <option value="255">+255</option>
                  <option value="256">+256</option>
                  <option value="257">+257</option>
                  <option value="258">+258</option>
                  <option value="260">+260</option>
                  <option value="261">+261</option>
                  <option value="262">+262</option>
                  <option value="263">+263</option>
                  <option value="264">+264</option>
                  <option value="265">+265</option>
                  <option value="266">+266</option>
                  <option value="267">+267</option>
                  <option value="268">+268</option>
                  <option value="269">+269</option>
                  <option value="27">+27</option>
                  <option value="30">+30</option>
                  <option value="31">+31</option>
                  <option value="32">+32</option>
                  <option value="33">+33</option>
                  <option value="331">+331</option>
                  <option value="34">+34</option>
                  <option value="350">+350</option>
                  <option value="351">+351</option>
                  <option value="352">+352</option>
                  <option value="353">+353</option>
                  <option value="354">+354</option>
                  <option value="355">+355</option>
                  <option value="356">+356</option>
                  <option value="357">+357</option>
                  <option value="358">+358</option>
                  <option value="359">+359</option>
                  <option value="36">+36</option>
                  <option value="370">+370</option>
                  <option value="371">+371</option>
                  <option value="372">+372</option>
                  <option value="373">+373</option>
                  <option value="374">+374</option>
                  <option value="375">+375</option>
                  <option value="376">+376</option>
                  <option value="377">+377</option>
                  <option value="378">+378</option>
                  <option value="380">+380</option>
                  <option value="381">+381</option>
                  <option value="386">+386</option>
                  <option value="39">+39</option>
                  <option value="40">+40</option>
                  <option value="41">+41</option>
                  <option value="420">+420</option>
                  <option value="421">+421</option>
                  <option value="423">+423</option>
                  <option value="43">+43</option>
                  <option value="44">+44</option>
                  <option value="45">+45</option>
                  <option value="46">+46</option>
                  <option value="47">+47</option>
                  <option value="48">+48</option>
                  <option value="49">+49</option>
                  <option value="501">+501</option>
                  <option value="502">+502</option>
                  <option value="503">+503</option>
                  <option value="504">+504</option>
                  <option value="505">+505</option>
                  <option value="506">+506</option>
                  <option value="507">+507</option>
                  <option value="509">+509</option>
                  <option value="51">+51</option>
                  <option value="52">+52</option>
                  <option value="53">+53</option>
                  <option value="54">+54</option>
                  <option value="55">+55</option>
                  <option value="56">+56</option>
                  <option value="57">+57</option>
                  <option value="58">+58</option>
                  <option value="591">+591</option>
                  <option value="592">+592</option>
                  <option value="593">+593</option>
                  <option value="594">+594</option>
                  <option value="595">+595</option>
                  <option value="596">+596</option>
                  <option value="597">+597</option>
                  <option value="598">+598</option>
                  <option value="599">+599</option>
                  <option value="60">+60</option>
                  <option value="61">+61</option>
                  <option value="62">+62</option>
                  <option value="63">+63</option>
                  <option value="64">+64</option>
                  <option value="65">+65</option>
                  <option value="66">+66</option>
                  <option value="673">+673</option>
                  <option value="674">+674</option>
                  <option value="675">+675</option>
                  <option value="676">+676</option>
                  <option value="677">+677</option>
                  <option value="678">+678</option>
                  <option value="679">+679</option>
                  <option value="682">+682</option>
                  <option value="684">+684</option>
                  <option value="685">+685</option>
                  <option value="686">+686</option>
                  <option value="689">+689</option>
                  <option value="7">+7</option>
                  <option value="81">+81</option>
                  <option value="82">+82</option>
                  <option value="84">+84</option>
                  <option value="850">+850</option>
                  <option value="855">+855</option>
                  <option value="856">+856</option>
                  <option value="880">+880</option>
                  <option value="90">+90</option>
                  <option value="91">+91</option>
                  <option value="92">+92</option>
                  <option value="93">+93</option>
                  <option value="94">+94</option>
                  <option value="95">+95</option>
                  <option value="960">+960</option>
                  <option value="961">+961</option>
                  <option value="962">+962</option>
                  <option value="963">+963</option>
                  <option value="964">+964</option>
                  <option value="965">+965</option>
                  <option value="966">+966</option>
                  <option value="967">+967</option>
                  <option value="968">+968</option>
                  <option value="971">+971</option>
                  <option value="972">+972</option>
                  <option value="973">+973</option>
                  <option value="974">+974</option>
                  <option value="976">+976</option>
                  <option value="977">+977</option>
                  <option value="98">+98</option>
                  <option value="992">+992</option>
                  <option value="993">+993</option>
                  <option value="994">+994</option>
                  <option value="995">+995</option>
                </select>
                <div className="mobileNumber-input-content">
                  <input
                    type="text"
                    name="mobileNumber"
                    value={memberData.mobileNumber}
                    className={`${
                      warningMemberData.mobileNumber || warningNumberLength
                        ? "error-input-text"
                        : ""
                    }`}
                    maxLength={numberMaxLength}
                    onChange={this.handleMemberData}
                  />
                  <div className="phone-comment-img">
                    <img src={phonecommentImage} alt="" />
                    <div className="phone-comment-text">
                      <Translation>
                        {t => <>{t("registerPage.commentSendPin")}</>}
                      </Translation>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {numberMaxLength !== "" && (
              <div className="hint-number-length">
                <Translation>
                  {t => <>{t("registerPage.numberFormat")}</>}
                </Translation>
                {numberMaxLength}
                <Translation>
                  {t => <>{t("registerPage.digits")}</>}
                </Translation>
              </div>
            )}

            {warningMemberData.mobileNumber ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.phoneError")}</>}
                </Translation>
              </div>
            ) : null}
            {warningNumberLength ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.phoneFormatError")}</>}
                </Translation>
              </div>
            ) : null}
          </div>
        </div>

        {/* 電子郵件 */}
        <div className={`register-form-row ${noEmail ? "no-email" : ""}`}>
          <div className="row50-content">
            <div className="register-form-row50">
              <div className="register-list-name">
                <Translation>{t => <>{t("registerPage.email")}</>}</Translation>
              </div>
              <input
                type="text"
                name="email"
                value={memberData.email}
                className={`email-input ${
                  warningMemberData.email || warningEmailType
                    ? "error-input-text"
                    : ""
                }`}
                onChange={this.handleMemberData}
              />
            </div>
            {warningMemberData.email ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.emailError")}</>}
                </Translation>
                <br />
                <Translation>
                  {t => <>{t("registerPage.ifNoEmail")}</>}
                </Translation>
                <br />
                <Translation>
                  {t => <>{t("registerPage.tickNoEmail")}</>}
                </Translation>
              </div>
            ) : null}
            {warningEmailType ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.emailFormatError")}</>}
                </Translation>
              </div>
            ) : null}
          </div>
          <div className="row50-content">
            <div className="register-form-row50">
              <div className="register-list-name">
                <Translation>
                  {t => <>{t("registerPage.confirmEmail")}</>}
                </Translation>
              </div>
              <input
                type="text"
                name="emailConfirm"
                value={memberData.emailConfirm}
                className={`email-input ${
                  warningMemberData.emailConfirm ||
                  warningEmailSame ||
                  warningEmailConfirmType
                    ? "error-input-text"
                    : ""
                }`}
                onChange={this.handleMemberData}
              />
            </div>
            {warningMemberData.emailConfirm ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.mandatoryField")}</>}
                </Translation>
              </div>
            ) : null}
            {warningEmailConfirmType ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.emailFormatError")}</>}
                </Translation>
              </div>
            ) : null}
            {warningEmailSame ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.notSame")}</>}
                </Translation>
              </div>
            ) : null}
          </div>
        </div>

        {/* 沒有電郵 */}
        <div className="register-form-row row-subText">
          <label className="register-checkbox-label">
            <input
              type="checkbox"
              name="noemail"
              onChange={this.noEmailOption}
            />
            <div />
            <span>
              <Translation>{t => <>{t("registerPage.noEmail")}</>}</Translation>
            </span>
          </label>
        </div>

        {/* 密碼 */}
        <div className="register-form-row">
          <div className="row50-content">
            <div className="register-form-row50">
              <div className="register-list-name">
                <Translation>
                  {t => <>{t("registerPage.password")}</>}
                </Translation>
              </div>
              <Translation>
                {t => (
                  <>
                    <input
                      type="password"
                      name="password"
                      value={memberData.password}
                      placeholder={t("registerPage.passwordComment")}
                      className={`password-input ${
                        warningMemberData.password ? "error-input-text" : ""
                      }`}
                      maxLength="15"
                      onChange={this.handleMemberData}
                    />
                  </>
                )}
              </Translation>
            </div>
            {warningMemberData.password ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.passwordError")}</>}
                </Translation>
              </div>
            ) : null}
            {warningPasswordLength ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.passwordFormatError")}</>}
                </Translation>
              </div>
            ) : null}
          </div>
          <div className="row50-content">
            <div className="register-form-row50">
              <div className="register-list-name">
                <Translation>
                  {t => <>{t("registerPage.confirmPassword")}</>}
                </Translation>
              </div>

              <Translation>
                {t => (
                  <>
                    <input
                      type="password"
                      name="passwordConfirm"
                      value={memberData.passwordConfirm}
                      placeholder={t("registerPage.passwordComment")}
                      className={`password-input ${
                        warningMemberData.passwordConfirm || warningPasswordSame
                          ? "error-input-text"
                          : ""
                      }`}
                      maxLength="15"
                      onChange={this.handleMemberData}
                    />
                  </>
                )}
              </Translation>
            </div>
            {warningMemberData.passwordConfirm ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.mandatoryField")}</>}
                </Translation>
              </div>
            ) : null}
            {warningPasswordConfirmLength ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.passwordFormatError")}</>}
                </Translation>
              </div>
            ) : null}
            {warningPasswordSame ? (
              <div className="error-text-row50">
                <Translation>
                  {t => <>{t("registerPage.notSame")}</>}
                </Translation>
              </div>
            ) : null}
          </div>
        </div>

        {/* 會員條款 */}
        <div className="register-form-row" style={{ flexWrap: "wrap-reverse" }}>
          <Translation>
            {t => <>{t("registerPage.acceptTerms1")}</>}
          </Translation>
          &nbsp;
          <a
            href={`//member.emphasis.com/hk/${
              lang === "en" ? "en" : "tc"
            }/terms-and-conditions.php`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Translation>{t => <>{t("registerPage.terms")}</>}</Translation>
          </a>
          &nbsp;
          <Translation>
            {t => <>{t("registerPage.acceptTerms2")}</>}
          </Translation>
        </div>
        <div className={`register-form-row `}>
          <label
            className={`register-checkbox-label member-agree-label ${
              warningAgreeTerms ? "error-agree-terms" : ""
            }`}
          >
            <input type="checkbox" name="noemail" onChange={this.agreeTerms} />
            <div />
            <p className="member-afree-content">
              <Translation>
                {t => <>{t("registerPage.agreeTerms1")}</>}
              </Translation>
              &nbsp;
              <a
                href={`//member.emphasis.com/hk/${
                  lang === "en" ? "en" : "tc"
                }/privacy-policy.php`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Translation>
                  {t => <>{t("registerPage.privacyPolicy")}</>}
                </Translation>
              </a>
              &nbsp;
              <Translation>{t => <>{t("registerPage.and")}</>}</Translation>
              &nbsp;
              <a
                href={`//member.emphasis.com/hk/${
                  lang === "en" ? "en" : "tc"
                }/cookie-policy.php`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Translation>
                  {t => <>{t("registerPage.cookiePolicy")}</>}
                </Translation>
              </a>
              &nbsp;
              <Translation>
                {t => <>{t("registerPage.agreeTerms2")}</>}
              </Translation>
            </p>
          </label>
          {warningAgreeTerms ? (
            <div className="error-text-list-name">
              <Translation>
                {t => <>{t("registerPage.termsError")}</>}
              </Translation>
            </div>
          ) : null}
        </div>
        <div className="register-form-row">
          <div className="register-desctext">
            <Translation>{t => <>{t("registerPage.descText1")}</>}</Translation>
            &nbsp;
            <a
              href={`//member.emphasis.com/hk/${
                lang === "en" ? "en" : "tc"
              }/privacy-policy.php`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Translation>
                {t => <>{t("registerPage.privacyPolicy")}</>}
              </Translation>
            </a>
            &nbsp;
            <Translation>{t => <>{t("registerPage.descText2")}</>}</Translation>
            <label className="desctext-label">
              <input type="checkbox" />
              <div />
              <Translation>
                {t => <>{t("registerPage.labelTeleSMS")}</>}
              </Translation>
            </label>
            <label className="desctext-label">
              <input type="checkbox" />
              <div />
              <Translation>
                {t => <>{t("registerPage.labelEmail")}</>}
              </Translation>
            </label>
            <Translation>
              {t => <>{t("registerPage.descTextLast")}</>}
            </Translation>
          </div>
        </div>

        {/* 表單有任一錯誤的提醒訊息 */}
        {warningFormMessage ? (
          <div className="register-form-row">
            <div className="form-error-message">
              <img src={phonecommentImage} alt="" />
              {this.state.warningFormMessageText === "NOT_FINISH" ? (
                <Translation>
                  {t => <>{t("registerPage.warningDescText")}</>}
                </Translation>
              ) : this.state.warningFormMessageText === "HAD_REGISTERED" ? (
                <Translation>
                  {t => <>{t("registerPage.hasBeenRegistered")}</>}
                </Translation>
              ) : this.state.warningFormMessageText ===
                "HAD_EMAIL_REGISTERED" ? (
                <Translation>
                  {t => <>{t("registerPage.emailHasBeenRegistered")}</>}
                </Translation>
              ) : (
                <Translation>
                  {t => <>{t("registerPage.warningDescText")}</>}
                </Translation>
              )}
            </div>
          </div>
        ) : null}

        {/* 提交 */}
        <div className="register-form-row">
          <button
            className="register-submit-button"
            onClick={this.submitMemberData}
          >
            <Translation>{t => <>{t("registerPage.submit")}</>}</Translation>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: state.loading.isLoading
  };
};
const mapDispatchToProps = () => {
  return {
    startLoading: bool => {
      loading.actions.startLoading(bool);
    },
    goCheckRegister: autoLoginFormData =>
      register.actions.goCheckRegister(autoLoginFormData)
  };
};

const withi18nRegisterForm = withTranslation()(RegisterForm);
const withRouterAndi18nRegisterForm = withRouter(withi18nRegisterForm);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouterAndi18nRegisterForm);
